import { getFeatureFlags } from 'core/flow-control';

export const getAppUiPermissions = () => {
    const { show_dynamic_upgrade_popup_ff } = getFeatureFlags();

    return {
        showDynamicUpgradePopupPermission: show_dynamic_upgrade_popup_ff,
    };
};
